<template>
  <div class="fault-popup-wrap" v-if="visible">
    <div class="header">
      <span>故障记录</span>
      <span class="iconfont icon-close" @click="closePopup"></span>
    </div>
    <el-table :data="data" height="330px" max-height="330px">
      <el-table-column
        align="center"
        v-for="col in thead"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      thead: [
        {
          label: '故障代码',
          prop: 'faultCode',
          width: '100px'
        },
        {
          label: '故障名称',
          prop: 'faultName'
        },
        {
          label: '传感器名称',
          prop: 'sensorName'
        },
        {
          label: '发生时间',
          prop: 'beginTimeD'
        }
      ]
    };
  },
  methods: {
    closePopup() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss">
@keyframes r_to_l {
  from {
    right: -440px;
  }
  to {
    right: 0;
  }
}
.fault-popup-wrap {
  width: 450px;
  position: fixed;
  right: -440px;
  bottom: 0;
  border-radius: 8px;
  border-left: 1px solid #00a7b3;
  border-top: 1px solid #00a7b3;
  background: #0c1620;
  overflow: hidden;
  animation: r_to_l 1s forwards;
  .header {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    color: #00a7b3;
    .icon-close {
      border-radius: 50%;
      overflow: hidden;
      display: inline-block;
      width: 18px;
      height: 18px;
      text-align: center;
      line-height: 18px;
      &:hover {
        color: #000;
        background: #eee;
      }
    }
  }
}
</style>
